import {PropsWithChildren, ReactElement, useEffect} from 'react';
import Div100vh from 'react-div-100vh';
import {Outlet} from 'react-router-dom';

import s from './Layout.module.css';

export interface LayoutProps {
  classNameMain?: string;
  header?: ReactElement;
  footer?: ReactElement;
  enableDiv100vh?: boolean;
}

export function Layout({
  classNameMain,
  header,
  footer,
  enableDiv100vh,
  children,
}: PropsWithChildren<LayoutProps>): JSX.Element {
  const renderPage = (): JSX.Element => {
    return (
      <>
        {header && header}
        <main className={classNameMain}>{children || <Outlet />}</main>
        {footer && footer}
      </>
    );
  };

  useEffect(() => {
    const root = document.getElementById('root');

    const canDisableMinHeight = enableDiv100vh && root;

    if (canDisableMinHeight) {
      root.style.minHeight = '0';
    }

    return () => {
      if (canDisableMinHeight) {
        root.style.minHeight = '';
      }
    };
  }, [enableDiv100vh]);

  if (!enableDiv100vh) {
    return renderPage();
  }

  return <Div100vh className={s.root}>{renderPage()}</Div100vh>;
}
